// relative
import { apiSlice } from '../../apiSlice';

export const userApiSlice = apiSlice.injectEndpoints({
  tagTypes: ['User'],
  endpoints: (builder) => ({
    getUserByEmail: builder.query({
      query: (email) => `Users/${encodeURIComponent(email)}`,
    }),
    getUsersByEmail: builder.query({
      query: (email) =>
        `Users?orderby=UserId&Email=eq(${encodeURIComponent(email)})&top=10000`,
    }),
    updateUser: builder.mutation({
      query: ({ email, patch }) => ({
        url: `Users/${encodeURIComponent(email)}`,
        method: 'PATCH',
        body: patch,
      }),
    }),
  }),
});

export const {
  useGetUserByEmailQuery,
  useGetUsersByEmailQuery,
  useUpdateUserMutation,
} = userApiSlice;
